let resizeTimer: ReturnType<typeof setTimeout> | null = null;
let resizeRaf: number | null = null;

/**
 * Debounced trigger for window resize event to avoid layout thrashing
 * when multiple components or effects request resize recalculations simultaneously.
 *
 * @param delayMs Delay before triggering resize on requestAnimationFrame (default 150ms)
 */
export const triggerWindowResize = (delayMs = 150): void => {
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  if (resizeRaf) {
    cancelAnimationFrame(resizeRaf);
  }

  resizeTimer = setTimeout(() => {
    resizeRaf = requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
    });
  }, delayMs);
};
